import * as React from 'react'

import { Date } from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

export const DateOfBirth = ({ isRequired = false }) => {
  const { getLabel } = useIntl()

  const labels = React.useMemo(
    () => ({
      title: getLabel('checkout.contact.dateofbirth'),
      error: getLabel('checkout.contact.dateofbirth.error'),
      tooltip: getLabel('checkout.contact.dateofbirth.tooltip'),
    }),
    [getLabel]
  )

  return (
    <Date
      label={labels.title}
      tooltipText={labels.tooltip}
      name="dateOfBirth"
      invalidDateErrorMessage={labels.error}
      required={isRequired}
    />
  )
}
